// LOGOUT_START
export const LOGOUT_START = 'LOGOUT_START';
// LOGOUT_SUCCESS
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
// LOGOUT_FAILURE
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
